export enum PlasticsMaterialStatus {
    Active = "Active",
    Obsolete = "Obsolete",
}
